import { types, Instance } from 'mobx-state-tree';
const { model, string, identifierNumber, number, maybeNull } = types;

export const LDAPCredentialsModel = model('LDAPCredentialsModel', {
  id: identifierNumber,
  ldapType: string,
  ldapName: string,
  host: string,
  domain: string,
  port: number,
  username: string,
  password: string,
  baseDn: string,
  awsRegion: maybeNull(string),
  ip: string,
  region: maybeNull(string),
  city: maybeNull(string),
  country: maybeNull(string),
});

export type ILDAPCredentialsModel = Instance<typeof LDAPCredentialsModel>;

export const LDAPSyncModel = model('LDAPSyncModel', {
  group: number,
  department: number,
  people: number,
  userGroup: number,
});

export type ILDAPSyncModel = Instance<typeof LDAPSyncModel>;

export const LDAPPasswordModel = model('LDAPPasswordModel', {
  password: string,
});

export type ILDAPPasswordModel = Instance<typeof LDAPPasswordModel>;
export const updateLDAPPass = model('UpdateLDAPPassword', {
  password: string,
});

export type IUpdateLDAPPassword = Instance<typeof updateLDAPPass>;
